import { Button as MuiButton, ButtonProps as MuiButtonProps } from "@mui/material";
import { SxProps, Theme } from '@mui/material/styles';
import { FC } from 'react';

interface ButtonProps extends MuiButtonProps { sx?: SxProps<Theme> }

const Button: FC<ButtonProps> = ({ children, sx = [], ...props }) => {
  return (
    <MuiButton
      {...props}
      variant='outlined'
      sx={[
        (theme) => ({
          fontFamily: theme.typography.primaryFont,
          letterSpacing: '0.1em',
          fontSize: '14px',
          padding: '10px, 20px',
          fontWeight: 700,
          color: 'black',
          backgroundColor: 'white',
          minWidth: 'fit-content',
          border: '2px solid',
          borderColor: theme.colors.primary,
          '&:hover': {
            border: '2px solid',
            backgroundColor: 'white',
            borderColor: theme.colors.primary
          }
        }),
        ...(Array.isArray(sx) ? sx : [sx])
      ]}>
      {children}
    </MuiButton>
  )
};

export default Button;